var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"border":"top","colored-border":"","type":"info","elevation":"2"}},[_vm._v(" Não há nenhum arquivo nesta pasta ainda :("),_c('br'),_vm._v(" "+_vm._s(_vm.addMessage)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }